import Dialog from './Dialog'
import Button from './Button'
import { Icon } from '@iconify/react'

const ConfirmDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = 'Confirm Action',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'danger',
  icon = 'mdi:alert-circle'
}) => {
  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  const variantClasses = {
    danger: 'text-danger',
    warning: 'text-warning',
    info: 'text-info',
    success: 'text-success',
  }

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            {cancelText}
          </Button>
          <Button 
            variant={variant === 'danger' ? 'danger' : variant === 'warning' ? 'warning' : 'primary'} 
            onClick={handleConfirm}
          >
            {confirmText}
          </Button>
        </>
      }
    >
      <div className="flex items-start gap-4">
        <div className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center ${variantClasses[variant]}/20`}>
          <Icon icon={icon} className={`text-2xl ${variantClasses[variant]}`} />
        </div>
        <div className="flex-1">
          <p className="text-text-dark">{message}</p>
        </div>
      </div>
    </Dialog>
  )
}

export default ConfirmDialog
